import React, { useRef, useState } from "react";
import {
  Text,
  View,
  Image,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  ScrollView,
  Platform
} from "react-native";
import Moment from "moment";
import Swiper from "react-native-swiper/src";
import { Ionicons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import Colors from "../../utilities/Color.js";
import CustomIcon from "../../components/CustomIcon";
import { getCards } from "../../redux/actions/CardActions";
import { Shadow } from "react-native-shadow-2";
import GenericButton from "../../components/GenericButton.js";

export default function CardsHomeScreen() {
  const visa_icon = require("../../assets/images/cards/visa.png");
  const mastercard_icon = require("../../assets/images/cards/mastercard.png");
  const cards = useSelector((state) => state.card.cards);
  const cardsLoaded = useSelector((state) => state.card.cardsLoaded);
  const navigation = useNavigation();
  //cards
  const win = Dimensions.get("window");
  const hasCards = cards.length != 0;
  // const hasCards = true;
  const headertext = hasCards ? "Manage my cards" : "Link my cards";
  const subheadertext = hasCards
    ? "Link or update your debit or credit cards"
    : "Link your Visa or Mastercard";
  const myBGColour = hasCards ? Colors.WHITE : Colors.MIDBLUE;
  const myFooterTextColour = hasCards ? Colors.DARKGRAY : Colors.WHITE;

  const hasCharity = useSelector((state) => state.user.userData.subscriberDetails.charityId) != undefined;
  const [charityNag, setNag] = useState(false);
  React.useEffect(() => {
    if (!cardsLoaded) {
      getCards();
    }
    if (!hasCharity && !charityNag) {
      setNag(true);
      navigation.navigate("NoCharityNotifaction");
    }
  }, [
    cardsLoaded, charityNag, hasCharity
  ]);

  return (
    <View style={[GlobalStyles.containerLB, { backgroundColor: myBGColour }]}>
      <ScrollView style={styles.scrollArea}>
        {win.width > 768 ? (
          <View style={GlobalStyles.fullHeaderBarY}>
            <MenuBar data="2" />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={[GlobalStyles.headerTextYellow]}>
                <Text style={GlobalStyles.headingStyle}>{headertext}</Text>
                <Text style={GlobalStyles.subheaderStyle}>{subheadertext}</Text>
              </View>
            </View>
          </View>
        ) : (
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="BM" />
            <View style={GlobalStyles.headerContainerKL}>
              <View style={[GlobalStyles.headerText]}>
                <Text style={GlobalStyles.headingStyle}>{headertext}</Text>
                <Text style={GlobalStyles.subheaderStyle}>{subheadertext}</Text>
              </View>
            </View>
          </View>
        )}
        <View style={GlobalStyles.containerNmax}>
          <View style={styles.bodyContainerFull}>
            {hasCards ? (
              <View style={styles.cardsRegistered}>
                {Platform.OS === "web" ?
                  <View>
                    {cards.map((card) => {
                      return (
                        <View style={styles.CCardContainer} key={card.id}>
                          <Shadow
                            distance={5}
                            startColor={Colors.LIGHTGRAY}
                            endColor={Colors.WHITE}
                            offset={[0, 0]}
                            style={styles.shadowcorners}
                          >
                            <View style={styles.CCardContainerInner}>
                              <View style={styles.cardHeaderContainer}>
                                <TouchableOpacity
                                  style={styles.removeLInkStyle}
                                  activeOpacity={0.5}
                                  onPress={() => navigation.navigate("CardsRemove", { cardId: card.id })}
                                >
                                  <Text style={styles.textRemoveStyle}>Remove</Text>
                                </TouchableOpacity>
                                <View style={styles.cardMiddleContainer}>
                                  <View style={styles.cardMiddleLeftContainer}>
                                    {card.issuer == "visa" ? (
                                      <Image style={styles.cc_icon} source={visa_icon} />
                                    ) : (
                                      <Image style={styles.cc_icon} source={mastercard_icon} />
                                    )}
                                  </View>
                                  <View style={styles.cardMiddleRightContainer}>
                                    <Text style={styles.textBodyStyleCardNum}>
                                      {card.cardMasked}
                                    </Text>
                                  </View>
                                  <View style={styles.cardMiddleFarRightContainer}>
                                    <Ionicons
                                      name="checkmark-circle"
                                      size={25}
                                      color={Colors.MIDBLUE}
                                    />
                                  </View>
                                </View>
                                <View style={styles.cardBottomContainer}>
                                  <View style={styles.cardBottomLeftContainer}>
                                    <Text style={styles.textLabelStyle}>
                                      CARD PROVIDER
                                    </Text>
                                    <Text style={styles.cardtextBodyStyle}>{card.provider}</Text>
                                  </View>
                                  <View style={styles.cardBottomRightContainer}>
                                    <Text style={styles.textLabelExpiresStyle}>
                                      EXPIRES
                                    </Text>
                                    <Text style={styles.cardtextBodyStyle}>
                                      {Moment(
                                        card.expiry,
                                        "YYYY-MM-DD"
                                      ).format("MM/YY")}
                                    </Text>
                                  </View>
                                </View>
                              </View>
                            </View>
                          </Shadow>
                        </View>
                      )
                    })}
                  </View>
                  : <View style={styles.wrapper}>
                    <Swiper
                      showsButtons={false}
                      horizontal={true}
                      showsPagination={true}
                      autoplay={false}
                      autoplayTimeout={30}
                      activeDotColor="#FFC72C"
                    >
                      {cards.map((card) => {
                        return (
                          <View style={styles.CCardContainer} key={card.id}>
                            <Shadow
                              distance={5}
                              startColor={Colors.LIGHTGRAY}
                              endColor={Colors.WHITE}
                              offset={[0, 0]}
                              style={styles.shadowcorners}
                            >
                              <View style={styles.CCardContainerInner}>
                                <View style={styles.cardHeaderContainer}>
                                  <TouchableOpacity
                                    style={styles.removeLInkStyle}
                                    activeOpacity={0.5}
                                    onPress={() => navigation.navigate("CardsRemove", { cardId: card.id })}
                                  >
                                    <Text style={styles.textRemoveStyle}>Remove</Text>
                                  </TouchableOpacity>
                                  <View style={styles.cardMiddleContainer}>
                                    <View style={styles.cardMiddleLeftContainer}>
                                      {card.issuer == "visa" ? (
                                        <Image style={styles.cc_icon} source={visa_icon} />
                                      ) : (
                                        <Image style={styles.cc_icon} source={mastercard_icon} />
                                      )}
                                    </View>
                                    <View style={styles.cardMiddleRightContainer}>
                                      <Text style={styles.textBodyStyleCardNum}>
                                        {card.cardMasked}
                                      </Text>
                                    </View>
                                    <View style={styles.cardMiddleFarRightContainer}>
                                      <Ionicons
                                        name="checkmark-circle"
                                        size={25}
                                        color={Colors.MIDBLUE}
                                      />
                                    </View>
                                  </View>
                                  <View style={styles.cardBottomContainer}>
                                    <View style={styles.cardBottomLeftContainer}>
                                      <Text style={styles.textLabelStyle}>
                                        CARD PROVIDER
                                      </Text>
                                      <Text style={styles.cardtextBodyStyle}>{card.provider}</Text>
                                    </View>
                                    <View style={styles.cardBottomRightContainer}>
                                      <Text style={styles.textLabelExpiresStyle}>
                                        EXPIRES
                                      </Text>
                                      <Text style={styles.cardtextBodyStyle}>
                                        {Moment(
                                          card.expiry,
                                          "YYYY-MM-DD"
                                        ).format("MM/YY")}
                                      </Text>
                                    </View>
                                  </View>
                                </View>
                              </View>
                            </Shadow>
                          </View>
                        )
                      })}
                    </Swiper>
                  </View>
                }
                <View style={styles.buttonAddCard}>
                  <GenericButton
                    buttonText='ADD CARD'
                    onPress={() => navigation.navigate("CardsAddNew")}
                  />
                </View>
              </View>
            ) : (
              <View style={styles.noCardsRegistered}>
                <View style={styles.addCardContainer}>
                  <View style={styles.cardHeaderContainer}>
                    <Text
                      style={[
                        GlobalStyles.headingStyle,
                        { textAlign: "center", fontSize: 18 },
                      ]}
                    >
                      Add your first card!
                    </Text>
                    <Text style={styles.textBodyStyle}>
                      Be rewarded with cashback online or in store with Aura
                      partners!
                    </Text>
                  </View>
                  <View style={styles.buttonContainerInvest}>
                    <GenericButton
                      buttonText='ADD CARD'
                      onPress={() => navigation.navigate("CardsAddNew")}
                    />
                  </View>
                </View>
                <View style={styles.whyTextBlock}>
                  <Text style={styles.textWhiteHeaderStyle}>
                    Why link your cards?
                  </Text>
                  <Text style={styles.textWhiteBodyStyle}>
                    Card linking opens up hundreds of additional online and in
                    store partners for you to shop at and earn Aura rewards. When
                    using your linked credit or debit card you can simply shop,
                    earn cashback, and build your wealth as you invest!
                  </Text>
                </View>
              </View>
            )}
            <View style={styles.bottonTextContainer}>
              <CustomIcon
                name={"icon-secure"}
                size={34}
                color="rgba(0,142,206,0.99)"
              />
              <Text style={[styles.footerText, { color: myFooterTextColour }]}>
                Rest assured we use bank level security
              </Text>
            </View>
          </View>
        </View>
      </ScrollView>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  wrapper: {
    height: 280,
  },
  bodyContainerFull: {
    paddingTop: 10,
    paddingLeft: 25,
    paddingRight: 25,
    alignItems: "center",
  },
  addCardContainer: {
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 25,
    marginBottom: 20,
    borderColor: Colors.WHITE,
    borderWidth: 1,
  },
  CCardContainer: {
    marginBottom: 20,
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 1,
    paddingRight: 1,
    width: "100%",
  },
  CCardContainerInner: {
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    paddingTop: 25,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 25,
    width: "100%",
  },
  shadowcorners: {
    width: "100%",
    paddingTop: 1,
    paddingBottom: 1,
    paddingLeft: 1,
    paddingRight: 1,
  },
  buttonContainerInvest: {
    flexDirection: "row",
    marginTop: 35,
    marginBottom: 15,
  },
  buttonAddCard: {
    marginTop: 35,
    marginBottom: 15,
    alignSelf: "center"
  },
  noCardsRegistered: {
    paddingTop: 20,
  },
  cardsRegistered: {
    paddingTop: 20,
    width: "100%",
  },
  cardHeaderContainer: {
    textAlign: "center",
  },
  cardMiddleContainer: {
    flexDirection: "row",
    paddingTop: 40,
    paddingBottom: 40,
    alignItems: "center",
  },
  cardMiddleLeftContainer: {
    flex: 1,
    alignItems: "flex-start",
  },
  cardMiddleRightContainer: {
    flex: 6,
    alignItems: "center",
  },
  cardMiddleFarRightContainer: {
    flex: 1,
    alignItems: "flex-end",
  },
  cardBottomContainer: {
    flexDirection: "row",
  },
  cardBottomLeftContainer: {
    flex: 7,
    alignItems: "flex-start",
  },
  cardBottomRightContainer: {
    flex: 1.5,
    alignItems: "flex-start",
  },
  textButtonStyle: {
    color: "black",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
    lineHeight: 14,
  },
  textBodyStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: Colors.DARKGRAY,
    fontSize: 14,
    lineHeight: 20,
  },
  textRemoveStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "right",
    color: Colors.MIDBLUE,
    fontSize: 12,
    lineHeight: 20,
  },
  textLabelStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: Colors.MIDGRAY,
    fontSize: 9,
    lineHeight: 20,
  },
  textLabelExpiresStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "left",
    color: Colors.MIDGRAY,
    fontSize: 9,
    lineHeight: 20,
  },
  whyTextBlock: {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 30,
    paddingRight: 30,
  },
  textWhiteHeaderStyle: {
    fontFamily: "montserrat-bold",
    textAlign: "center",
    fontSize: 18,
    lineHeight: 22,
    color: Colors.WHITE,
    paddingBottom: 20,
  },
  textWhiteBodyStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    fontSize: 14,
    lineHeight: 20,
    color: Colors.WHITE,
  },
  textBodyStyleCardNum: {
    fontFamily: "montserrat-medium",
    textAlign: "center",
    letterSpacing: 3,
    fontSize: 14,
    lineHeight: 20,
    color: Colors.DARKGRAY,
  },
  cardtextBodyStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "left",
    color: Colors.DARKGRAY,
    fontSize: 12,
    lineHeight: 20,
  },
  cardtextBodyLeftStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "left",
    color: Colors.DARKGRAY,
    fontSize: 12,
    lineHeight: 20,
  },
  cardtextBodyRightStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "right",
    color: Colors.DARKGRAY,
    fontSize: 12,
    lineHeight: 20,
  },
  bottonTextContainer: {
    flexDirection: "row",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 100,
  },
  footerText: {
    color: "#ffff",
    fontFamily: "montserrat-italic",
    textAlign: "center",
    fontSize: 12,
    lineHeight: 16,
    color: Colors.WHITE,
    paddingLeft: 5,
  },
  cc_icon: {
    width: 45,
    height: 32,
  },
});
